import React, {useState, useEffect} from 'react';
import {AnswerButton, ResultBar} from "./index";
import {PictoBadge} from "../Common";
import {useDispatch, useSelector} from "react-redux";
import noImage from '../../image/no_image.png'
import {transitionToDetail} from "../../modules/Transition/actions"


const ListItem = (props) => {
    const dispatch = useDispatch();
    const usersList = useSelector(state => state.users);
    const [whichChecked, toggleCheck] = useState(props.whichChecked);
    const [animation, toggleAnimation] = useState(true);

    const toggleAnswerButton = (event) => {
        const isChecked = document.getElementById(event.id).checked;
        toggleAnimation(!animation)

        if (isChecked && event.value === whichChecked) {
            document.getElementById(event.id).checked = !isChecked;
            toggleCheck("");
            return props.select(event.name, "")
        } else {
            toggleCheck(event.value);    // A || B
            return props.select(event.name, event.value)
        }
    }
    
    useEffect(() => {
        // Determine the default checked state
        switch (whichChecked) {
            case 'A':
                document.getElementById(props.id + "_A").checked = true;
                break;
            case 'B':
                document.getElementById(props.id + "_B").checked = true;
                break;
        }
    }, []);

    const value = props.value;
    const image = (value.image !== "") ? value.image : noImage;
    const nickName = usersList[value.creator_id];

    const hasSomeoneAnswered = (value.result && Object.keys(value.result).length > 0);
    let aPercent = 0;
    if (hasSomeoneAnswered) {
        const result = Object.keys(value.result);
        const sum = result.length;
        const aResult = result.filter((index) => { return value.result[index] === "A" });
        const aNumber = aResult.length;
        aPercent = aNumber / sum * 100;
    } else {
        aPercent = 50
    }

    // Calculate the percentage of
    let fixedAPercent = aPercent.toFixed(1);
    let fixedBPercent = (100 - aPercent).toFixed(1);
    const roundedPercent = Math.round(aPercent);

    return (
        <article className="p-grid__item">
            <h3 onClick={() => dispatch(transitionToDetail(props.id))}>{value.question}</h3>
            <div className="c-grid__row" onClick={() => dispatch(transitionToDetail(props.id))}>
                <PictoBadge type="image" image={value.image} />
                <PictoBadge type="internet" url={value.url} />
                <span>{nickName}</span>
            </div>
            <div className="p-grid__item-answer" onClick={() => dispatch(transitionToDetail(props.id))}>
                <div>
                    <img src={image} alt={"Thumbnail of the question"} />
                </div>
                <div>
                    <p>Ａ：{value.answer_a}</p>
                    <p>Ｂ：{value.answer_b}</p>
                </div>
            </div>
            <div className="p-grid-result" onClick={() => dispatch(transitionToDetail(props.id))}>
                <div>{fixedAPercent}%</div>
                <div>{fixedBPercent}%</div>
            </div>
            <div className="p-grid__row-center">
                <AnswerButton id={props.id} type="A" toggle={toggleAnswerButton} />
                <ResultBar percent={roundedPercent} />
                <AnswerButton id={props.id} type="B" toggle={toggleAnswerButton}/>
            </div>
        </article>
    )
};

export default ListItem